import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { loadActivities } from 'bundles/apex/deals/show/store/activities/search/actions';

import Create from './create';
import Card from 'bundles/apex/card';
import InboxEmailAddress from './inbox_email_address';
import Results from './results';
import LoadingShimmer from 'shared/loading_shimmer';

export function ActivitiesCard({ activities, loadActivities }) {
  useEffect(() => {
    if (!activities) {
      loadActivities();
    }
  }, [activities]);

  return (
    <Card
      className="deal-activities-card d-flex flex-column"
      controls={<Create/>}
      label="Activities"
      labelControls={<InboxEmailAddress />}
      overflowAuto
      verticalBody
    >
      {activities ? <Results /> : <LoadingShimmer />}
    </Card>
  );
}

ActivitiesCard.propTypes = {
  activities: PropTypes.array,
  loadActivities: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  activities: state.activitiesSearch.activities,
});

const mapDispatchToProps = {
  loadActivities,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesCard);
